import { ChangeEvent } from "react";
import { useTranslation } from "next-i18next";
import { DivCheckbox } from "@talladega/components";
import {
  FilterAction,
  FilterActions,
  FilterKeys,
  PassengerCapacityFilter,
  VehicleFilter,
} from "../types/vehicleFilter";
import FilterDisclosure from "./FilterDisclosure";

type Props = {
  vehicleFilters: VehicleFilter[];
  passengerCapacities: number[];
  onUpdate(filterAction: FilterAction): void;
};

const VehiclePassengerCapacityFilter = ({
  vehicleFilters,
  passengerCapacities,
  onUpdate,
}: Props) => {
  const { t } = useTranslation(["common", "vehiclesFilters"]);
  const passengerCapacitiesFilter = vehicleFilters.filter(
    (f) => f.key === FilterKeys.PassengerCapacity
  ) as PassengerCapacityFilter[];

  const selectedPassengerCapacities = passengerCapacitiesFilter.map(
    (f) => f.state
  );

  const handleCheckChange = (
    event: ChangeEvent<HTMLInputElement>,
    displayPassengerCapacity: {
      id: number;
    }
  ) => {
    if (event.target.checked) {
      onUpdate({
        type: FilterActions.AddPassengerCapacityFilter,
        payload: {
          id: displayPassengerCapacity.id.toString(),
          name: displayPassengerCapacity.id.toString(),
        },
      });
    } else {
      onUpdate({
        type: FilterActions.RemoveByIdAndType,
        payload: {
          id: displayPassengerCapacity.id.toString(),
          type: FilterKeys.PassengerCapacity,
        },
      });
    }
  };
  return (
    <FilterDisclosure
      headerText={t("vehiclesFilters:passenger_capacity")}
      active={selectedPassengerCapacities.length > 0}
    >
      <ul className="body-3 grid grid-cols-2 gap-2">
        {passengerCapacities &&
          passengerCapacities.map((pc) => (
            <li key={pc}>
              <DivCheckbox
                id={`passengerCapacity${pc}Filter`}
                objectValue={{
                  id: pc,
                  name: {
                    english: t("common:seats", {
                      number: pc,
                    }),
                    french: t("common:seats", {
                      number: pc,
                    }),
                  },
                  order: pc,
                }}
                className="flex-row"
                onChangeEvent={handleCheckChange}
                isChecked={
                  selectedPassengerCapacities
                    .map((x) => x.id)
                    .indexOf(pc.toString()) > -1
                }
              >
                {t("common:seats", {
                  number: pc,
                })}
              </DivCheckbox>
            </li>
          ))}
      </ul>
    </FilterDisclosure>
  );
};

export default VehiclePassengerCapacityFilter;
